import { render, staticRenderFns } from "./Tema1_1-2.vue?vue&type=template&id=a108415a&"
import script from "./Tema1_1-2.vue?vue&type=script&lang=js&"
export * from "./Tema1_1-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports